export default __webpack_public_path__ + "static/media/106.33ce0cb8.jpg";